module.exports = __webpack_public_path__ + "img/undertakingCases4.873dd115.jpg";